/* eslint-disable no-alert */
/* eslint-disable no-unused-vars */
/* eslint-disable no-restricted-globals */
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

// Sagas
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import {
  Row, Col, Card, CardBody, CardHeader,
} from 'reactstrap';

import {
  Table, Tbody, Tr, Th, Td,
} from 'react-super-responsive-table';

import moment from 'moment';
import toastr from 'toastr';
import 'toastr/build/toastr.min.css';

// import { Can } from '../../utilities/Can';
import BaseGrid from '../../components/Common/BaseGrid';
import { get, del } from '../../helpers/api_helper';

function TVPallet(props) {
  toastr.options = {
    positionClass: 'toast-top-right',
    newestOnTop: true,
  };

  const { t } = props;

  const { palletId } = useParams();

  const [entity, setEntity] = useState(null);
  const [signal, setSignal] = useState(0);

  useEffect(() => {
    const loadEntity = async () => {
      try {
        const response = await get(`/api/tvs/pallets/${palletId}`);
        setEntity(response);
      } catch (error) {
        toastr.error(error.message, 'Error');
      }
    };

    loadEntity();
  }, []);

  const removeTv = async (tv) => {
    try {
      if (confirm(t('Are you sure?'))) {
        await del(`/api/tvs/pallets/${palletId}/${tv.id}`);

        setSignal(signal + 1);
      }
    } catch (error) {
      toastr.error(error.message, t('Error removing TV'));
    }
  };

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Row>
          <Col md="5">
            <Card>
              <CardHeader className="bg-transparent border-bottom">
                {t('Pallet Information')}
              </CardHeader>
              <CardBody>
                <div className="table-responsive">
                  <Table size="sm" className="table table-bordered table-striped">
                    <Tbody>
                      <Tr>
                        <Th>{t('ID')}</Th>
                        <Td>{entity === null ? '--' : entity.id.toString(36)}</Td>
                      </Tr>
                    </Tbody>
                  </Table>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>

        <Row>
          <Col md="12">
            <Card>
              <CardHeader className="bg-transparent border-bottom">
                {t('Pallet Manifest')}
              </CardHeader>
              <CardBody>
                <BaseGrid
                  url="/api/tvs"
                  hasSearch
                  shouldUpdate={signal}
                  filters={`pallet_id=${palletId}`}
                  config={
                  {
                    columns: {
                      id: {
                        label: 'ID',
                        sort: true,
                      },
                      user: {
                        label: 'User',
                        sort: true,
                        format: (value) => (value ? value.display_name : ''),
                      },
                      sjn: {
                        label: 'SJN',
                        sort: true,
                      },
                      classification: {
                        label: 'Classification',
                        sort: true,
                        style: { textTransform: 'capitalize', fontSize: '19px', fontWeight: 'bold' },
                      },
                      truck: {
                        label: 'Origin',
                        sort: true,
                        html: true,
                        format: (value) => {
                          if (value) {
                            return `${value.supplier ? value.supplier.name : ''}: <a href="/sourcing/truck/${value.id}">${value.reference}</a>`;
                          }
                          return '--';
                        },
                      },
                      brand: {
                        label: 'Brand',
                        sort: true,
                      },
                      model: {
                        label: 'Model',
                        sort: true,
                      },
                      device: {
                        label: 'Device',
                        sort: false,
                        html: true,
                        format: (value) => {
                          let text = '';
                          if (value && value.marketing_title !== null) {
                            text += value.marketing_title;
                            text += '<br />';
                          }
                          text += value ? value.id : '';
                          return text;
                        },
                      },
                      serial: {
                        label: 'Serial',
                        sort: true,
                      },
                      created_at: {
                        label: 'Created',
                        date: {
                          format: (date) => (moment(date).fromNow()),
                          timezone: process.env.LOCAL_TZ,
                        },
                      },
                      actions: {
                        label: 'Actions',
                        actions: [
                          {
                            key: 'delete',
                            icon: 'mdi mdi-close-thick',
                            class: 'btn btn-sm btn-soft-dark',
                            alt: props.t('Remove'),
                            click: removeTv,
                          },
                        ],
                      },
                    },
                    pagination: {
                      sort: 'id',
                      direction: 'desc',
                      perPage: 30,
                    },
                  }
                  }
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  );
}

TVPallet.defaultProps = {
  t: (x) => (x),
};

TVPallet.propTypes = {
  t: PropTypes.any,
};

export default connect(() => ({

}), {})(withTranslation()(TVPallet));
